<router-outlet></router-outlet>

<ngx-spinner type="ball-clip-rotate"></ngx-spinner>
